import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Alert,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap";
import Switch from "react-switch";
import classnames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useSelector } from "react-redux";
// Redux
import { withRouter, Link } from "react-router-dom";

// Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
//Constants
import { API_WEB_URLS } from "../../constants/constAPI";
//Store
import { compose } from "recompose";
import { container } from "../../store/Containers/cntCommon";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
  Fn_ChangeStateValue,
} from "../../store/functions";

export const DateString = dd => {
  let d1 = dd.replace("-", "");
  let d2 = d1.replace("-", "");

  return d2;
};

class Screen4 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      formData: {
        title: 'Mr',
        firstName: 'Rajesh',
        middleName: 'Kumar',
        lastName: 'Sharma',
        gender: 'Male',
        dob: '1990-05-15',
        fatherName: 'Ramesh Sharma',
        motherName: 'Sunita Sharma',
        country: 1, // INDIA
        maritalStatus: 1, // Single
        occupation: 1, // Salaried
        annualIncome: 2, // 1-5 Lakhs
        pepDeclaration: 'No',
        address: {
          sameAsAadhaar: true,
          address1: 'Flat 203, Krishna Apartments',
          address2: 'Sector 15, Rohini',
          address3: 'New Delhi',
          pinCode: '110085',
          country: 'INDIA'
        },
        documentType: 'PAN',
        residencyStatus: 'resident',
        panNumber: 'BRUPS7784L'
      },
      activeTab: 1,
      passedSteps: [1],
      BrowseImage1: "",
      BrowseImage2: "",
      UserImage: "",
      Signature: "",
      //dropdowns
      membershipType: [],
      maritalStatus: [],
      bloodGroup: [],
      gender: [],
      education: [],
      profession: [],
      relationShip: [],
      nationality: [],
      typeofRegCert: [],
      memberid: 0,
      name: "",
      email: "",
      aid: 0,
      fo3: false,
      Gender: 0,
      MaritalStatus: 0,
      success_msg: false,
      F_MISScheme: 0,
      IsOvertime: false,
      EmpBasic: [],
      searchText: '',
      idType: 'UID',
      aadhaarNumber: '',
      consentChecked: false,
      // Dropdown options arrays
      stateOptions: [
        { Id: 1, Name: "Delhi" },
        { Id: 2, Name: "Maharashtra" },
        { Id: 3, Name: "Karnataka" },
        { Id: 4, Name: "Tamil Nadu" },
        { Id: 5, Name: "Uttar Pradesh" }
      ],
      cityOptions: [
        { Id: 1, Name: "New Delhi" },
        { Id: 2, Name: "Mumbai" },
        { Id: 3, Name: "Bangalore" },
        { Id: 4, Name: "Chennai" },
        { Id: 5, Name: "Lucknow" }
      ],
      occupationOptions: [
        { Id: 1, Name: "Government Service" },
        { Id: 2, Name: "Private Service" },
        { Id: 3, Name: "Business" },
        { Id: 4, Name: "Self Employed" },
        { Id: 5, Name: "Professional" },
        { Id: 6, Name: "Homemaker" },
        { Id: 7, Name: "Student" }
      ],
      maritalStatusOptions: [
        { Id: 1, Name: "Single" },
        { Id: 2, Name: "Married" },
        { Id: 3, Name: "Widowed" },
        { Id: 4, Name: "Divorced" }
      ],
      countryOptions: [
        { Id: 1, Name: "INDIA" },
        { Id: 2, Name: "UAE" },
        { Id: 3, Name: "SINGAPORE" }
      ],
      annualIncomeOptions: [
        { Id: 1, Name: "Below ₹2.5 Lakh" },
        { Id: 2, Name: "₹2.5 Lakh - ₹5 Lakh" },
        { Id: 3, Name: "₹5 Lakh - ₹10 Lakh" },
        { Id: 4, Name: "Above ₹10 Lakh" }
      ],
      religionOptions: [
        { Id: 1, Name: "Hindu" },
        { Id: 2, Name: "Muslim" },
        { Id: 3, Name: "Sikh" },
        { Id: 4, Name: "Christian" },
        { Id: 5, Name: "Others" }
      ],
      categoryOptions: [
        { Id: 1, Name: "General" },
        { Id: 2, Name: "OBC" },
        { Id: 3, Name: "SC" },
        { Id: 4, Name: "ST" }
      ]
    };
    this.obj = this;
    this.nameFieldRef = React.createRef();
    this.formTitle = "User";
    this.breadCrumbTitle = "User Master";
    this.breadCrumbItem = "Add " + this.formTitle;
    this.API_URL = API_WEB_URLS.MASTER + "/0/token/User";
    this.API_URL_SAVE = API_WEB_URLS.UserMaster + "/0/token";
    this.pushFormName = "/UserMaster";
    this.rtPage_Print = "/membersynopsisprint";

    //Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnCancel_onClick = this.btnCancel_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
  }

  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (this.nameFieldRef.current) {
      this.nameFieldRef.current.focus();
    }
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
    });
    
    Fn_FillListData(
      this.obj,
      "UserType",
      API_WEB_URLS.MASTER + "/0/token/UserType/Id/0"
    );
    //Filling DropDowns
   
    const { id } = this.props.match.params;
    if (id) {
      this.setState({ id: id });
      this.breadCrumbItem = "Edit " + this.formTitle;
      Fn_DisplayData(this.obj, id, this.API_URL + "/Id");
    } else {
      this.setState({ id: 0 });
    }
  }

  btnSave_onClick(event, formData) {
    let vformData = new FormData();

    vformData.append("Name", formData.Name);
    vformData.append("Password", formData.Password);
    vformData.append("F_UserType", formData.F_UserType);
    vformData.append("UserId", this.state.aid);
    if (!this.state.id) {
      Fn_AddEditData(
        this.obj,
        { arguList: { id: 0, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "memberid"
      );
    } else
      Fn_AddEditData(
        this.obj,
        { arguList: { id: this.state.id, formData: vformData } },
        this.API_URL_SAVE,
        this.pushFormName,
        true,
        "kuku"
      );

  }

  btnGoBack_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  btnCancel_onClick = event => {
    event.preventDefault();
    //this.props.history.goBack();
    this.props.history.push(this.pushFormName);
  };

  // Add helper method to get dropdown label
  getDropdownLabel = (options, id) => {
    const option = options.find(opt => opt.Id === id);
    return option ? option.Name : '';
  }

  render() {
    // Common styles that can be reused
    const inputStyle = {
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px',
      padding: '8px 12px',
      width: '100%',
      marginBottom: '15px'
    };

    const labelStyle = {
      fontSize: '14px',
      color: '#495057',
      marginBottom: '8px',
      display: 'block'
    };

    const sectionStyle = {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '4px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      marginBottom: '20px'
    };

    return (
      <div className="page-content" style={{ padding: '20px' }}>
        <Container fluid>
          {/* Header Note */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            marginBottom: '20px',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#666',
            border: '1px solid #dee2e6'
          }}>
            Note that details received in ekyc are autofilled & not changed in this screen
          </div>

          {/* Scrollable Form Container */}
          <div style={{
            height: 'calc(100vh - 200px)',
            overflowY: 'auto',
            padding: '20px',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            backgroundColor: '#fff',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
            msOverflowStyle: '-ms-autohiding-scrollbar'
          }}>
            <Form>
              {/* Personal Details Section */}
              <div style={sectionStyle}>
                <h5 style={{
                  color: '#333',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontSize: '16px'
                }}>Personal Details</h5>

                {/* Title Selection */}
                <Row className="mb-3">
                  <Col md={12}>
                    <div style={{ display: 'flex', gap: '15px' }}>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="title"
                          value="Mr"
                          style={{ marginRight: '5px' }}
                        /> Mr
                      </Label>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="title"
                          value="Mrs"
                          style={{ marginRight: '5px' }}
                        /> Mrs
                      </Label>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="title"
                          value="Ms"
                          style={{ marginRight: '5px' }}
                        /> Ms
                      </Label>
                    </div>
                  </Col>
                </Row>

                {/* Name Fields */}
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        First Name <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        disabled
                        value={this.state.formData.firstName}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={labelStyle}>Middle Name</Label>
                      <Input 
                        type="text"
                        value={this.state.formData.middleName}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Last Name <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        disabled
                        value={this.state.formData.lastName}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Gender Selection */}
                <Row className="mb-3">
                  <Col md={12}>
                    <Label style={labelStyle}>
                      Gender <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <div style={{ display: 'flex', gap: '15px' }}>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="gender"
                          value="Male"
                          style={{ marginRight: '5px' }}
                        /> Male
                      </Label>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="gender"
                          value="Female"
                          style={{ marginRight: '5px' }}
                        /> Female
                      </Label>
                      <Label className="d-inline-block">
                        <Input
                          type="radio"
                          name="gender"
                          value="TG"
                          style={{ marginRight: '5px' }}
                        /> TG
                      </Label>
                    </div>
                  </Col>
                </Row>

                {/* Additional Fields */}
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Date of Birth (DD/MM/YYYY) <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        disabled
                        value={this.state.formData.dob}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Father/Husband&apos;s Name <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        value={this.state.formData.fatherName}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Mother&apos;s Maiden Name <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        value={this.state.formData.motherName}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Country <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="text"
                        value={this.state.formData.country}
                        style={inputStyle}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Marital Status <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="select"
                        value={this.state.formData.maritalStatus}
                        onChange={(e) => this.setState({
                          formData: {
                            ...this.state.formData,
                            maritalStatus: parseInt(e.target.value)
                          }
                        })}
                        style={inputStyle}
                      >
                        <option value="">Select</option>
                        {this.state.maritalStatusOptions.map(option => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        Select Occupation <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <Input 
                        type="select"
                        value={this.state.formData.occupation}
                        onChange={(e) => this.setState({
                          formData: {
                            ...this.state.formData,
                            occupation: parseInt(e.target.value)
                          }
                        })}
                        style={inputStyle}
                      >
                        <option value="">Select</option>
                        {this.state.occupationOptions.map(option => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                {/* PEP Declaration */}
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label style={labelStyle}>
                        PEP Declaration <span style={{ color: 'red' }}>*</span>
                      </Label>
                      <div style={{ display: 'flex', gap: '15px' }}>
                        <Label className="d-inline-block">
                          <Input
                            type="radio"
                            name="pepDeclaration"
                            value="No"
                            style={{ marginRight: '5px' }}
                          /> NO
                        </Label>
                        <Label className="d-inline-block">
                          <Input
                            type="radio"
                            name="pepDeclaration"
                            value="Yes"
                            style={{ marginRight: '5px' }}
                          /> YES
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                {/* Communication Address */}
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '15px',
                  borderRadius: '4px',
                  marginTop: '20px'
                }}>
                  <h6 style={{
                    marginBottom: '15px',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}>Communication Address</h6>

                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input type="checkbox" /> Communication address same as Aadhaar Address
                    </Label>
                  </FormGroup>

                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" /> Communication address different from Aadhaar Address
                    </Label>
                  </FormGroup>

                  <Row className="mt-3">
                    <Col md={4}>
                      <FormGroup>
                        <Label style={labelStyle}>
                          Address 1 <span style={{ color: 'red' }}>*</span>
                        </Label>
                        <Input 
                          type="text"
                          value={this.state.formData.address1}
                          style={inputStyle}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label style={labelStyle}>Address 2</Label>
                        <Input 
                          type="text"
                          value={this.state.formData.address2}
                          style={inputStyle}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label style={labelStyle}>Address 3</Label>
                        <Input 
                          type="text"
                          value={this.state.formData.address3}
                          style={inputStyle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label style={labelStyle}>
                          Pin Code <span style={{ color: 'red' }}>*</span>
                        </Label>
                        <Input 
                          type="text"
                          value="110035"
                          disabled
                          style={inputStyle}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label style={labelStyle}>
                          Country <span style={{ color: 'red' }}>*</span>
                        </Label>
                        <Input 
                          type="text"
                          value="INDIA"
                          disabled
                          style={inputStyle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Professional Details */}
              <div style={sectionStyle}>
                <h5 style={{
                  color: '#333',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontSize: '16px'
                }}>Professional Details</h5>
                
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>Occupation</Label>
                      <Input 
                        type="select"
                        value={this.state.formData.occupation}
                        onChange={(e) => this.setState({
                          formData: {
                            ...this.state.formData,
                            occupation: parseInt(e.target.value)
                          }
                        })}
                        style={{
                          ...inputStyle,
                          backgroundColor: '#fff',
                          cursor: 'pointer'
                        }}
                      >
                        <option value="">Select</option>
                        {this.state.occupationOptions.map(option => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label style={labelStyle}>Annual Income</Label>
                      <Input 
                        type="select"
                        value={this.state.formData.annualIncome}
                        onChange={(e) => this.setState({
                          formData: {
                            ...this.state.formData,
                            annualIncome: parseInt(e.target.value)
                          }
                        })}
                        style={{
                          ...inputStyle,
                          backgroundColor: '#fff',
                          cursor: 'pointer'
                        }}
                      >
                        <option value="">Select</option>
                        {this.state.annualIncomeOptions.map(option => (
                          <option key={option.Id} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {/* FATCA Declaration */}
              <div style={sectionStyle}>
                <h5 style={{
                  color: '#333',
                  fontWeight: '600',
                  marginBottom: '20px',
                  fontSize: '16px'
                }}>Other Details</h5>

                {/* PAN/Form 60 Selection */}
                <div style={{ marginBottom: '20px' }}>
                  <Label className="d-inline-block mr-4" style={{ marginRight: '20px' }}>
                    <Input
                      type="radio"
                      name="documentType"
                      value="PAN"
                      defaultChecked
                      style={{ marginRight: '8px' }}
                    /> PAN
                  </Label>
                  <Label className="d-inline-block">
                    <Input
                      type="radio"
                      name="documentType"
                      value="Form60"
                      style={{ marginRight: '8px' }}
                    /> Form 60
                  </Label>
                </div>

                {/* FATCA Declaration Box */}
                <div style={{
                  border: '1px solid #28a745',
                  borderRadius: '4px',
                  padding: '15px',
                  marginBottom: '20px'
                }}>
                  <h6 style={{
                    color: '#28a745',
                    marginBottom: '15px',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}>
                    FATCA Declaration
                  </h6>
                  <p style={{ 
                    fontSize: '14px', 
                    marginBottom: '15px',
                    color: '#666'
                  }}>
                    (I am an Indian resident paying taxes only in India)
                  </p>
                </div>

                {/* Residency Declaration */}
                <div style={{ marginBottom: '20px' }}>
                  <Label className="d-block mb-3">
                    <Input
                      type="radio"
                      name="residency"
                      defaultChecked
                      style={{ marginRight: '8px' }}
                    /> I am tax resident of India
                  </Label>
                  <Label className="d-block">
                    <Input
                      type="radio"
                      name="residency"
                      style={{ marginRight: '8px' }}
                    /> I am tax resident of outside India
                  </Label>
                </div>

                {/* Declaration Text */}
                <div style={{
                  fontSize: '14px',
                  color: '#666',
                  lineHeight: '1.5',
                  marginBottom: '20px'
                }}>
                  I understand that the Bank is relying on this information for the purpose of determining my status in compliance with FATCA/CRS. The Bank is not able to offer any tax advice on FATCA/CRS or its impact. I shall seek advice from professional tax advisor for any tax questions. I certify that I provide the information on this form and to the best of my knowledge and belief the certification is true, correct, and complete including the taxpayer identification number /functional equivalent number of the applicant
                </div>

                {/* Submit Button */}
                <div style={{ textAlign: 'center' }}>
                  <Button 
                    style={{
                      backgroundColor: '#000',
                      border: 'none',
                      padding: '8px 30px',
                      borderRadius: '4px',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>

              {/* Form Actions */}
              <div style={{
                position: 'sticky',
                bottom: '0',
                backgroundColor: '#fff',
                padding: '15px 0',
                borderTop: '1px solid #dee2e6',
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px'
              }}>
                <Button 
                  style={{
                    backgroundColor: '#6c757d',
                    border: 'none',
                    padding: '8px 20px',
                    borderRadius: '4px',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Previous
                </Button>
                <Button 
                  style={{
                    backgroundColor: '#007bff',
                    border: 'none',
                    padding: '8px 20px',
                    borderRadius: '4px',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Next
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    );
  }
}
export default compose(container)(Screen4);
